import colors from "../../base/colors";

import pxToRem from "../../functions/pxToRem";

const { transparent,dark } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "grid",
      alignItems: "center",
      //padding: `0 ${pxToRem(12)} !important`,
      color: dark.main,

      //fontSize: size.sm,
      //borderRadius: borderRadius.sm,
      paddingTop: pxToRem(4),
      paddingLeft: pxToRem(4),
      paddingRight: pxToRem(4),

      "&:selected": {
        color: dark.main,
      },

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      //display: "none",
      color: dark.main,
    },
  },
};

export default select;
